import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'xux-icon',
  templateUrl: 'xux-icon.component.html',
  styleUrls: ['./xux-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxIconComponent {
  @Input('icon') public icon: string = '';
}
